/*
 * KidsBlock Link modal copy.
 *
 * The editor ships its interface in English and takes translations from
 * `openblock-l10n`, but that package is the upstream project's and does not know
 * about the local hardware helper. The strings below are this project's own, so
 * they are carried here and merged into the locale tables in
 * `src/reducers/locales.js` - the same way `auth-messages.js` supplies the
 * account screens.
 *
 * A locale left out falls back to English.
 */
const kidsblockLinkMessages = {
    'en': {
        'gui.kidsblockLink.modalTitle': 'KidsBlock Link is required',
        'gui.kidsblockLink.modalIntro':
            'KidsBlock online reaches your board through KidsBlock Link. Please keep it running.',
        'gui.kidsblockLink.step1Title':
            'First time here? Download and install KidsBlock Link for your system.',
        'gui.kidsblockLink.step2Title':
            'Keep KidsBlock Link running in the background to connect and upload code to your board.',
        'gui.kidsblockLink.downloadWindows': 'Download',
        'gui.kidsblockLink.downloadWindowsActive': 'Click to Download',
        'gui.kidsblockLink.downloadMac': 'Download',
        'gui.kidsblockLink.downloadMacActive': 'Click to Download',
        'gui.kidsblockLink.detecting': 'Looking for KidsBlock Link on this computer...',
        'gui.kidsblockLink.installedQuestion': 'Already installed KidsBlock Link?',
        'gui.kidsblockLink.blockedByBrowser': 'This browser is blocking pages from reaching services ' +
            'on your computer (local network access is denied). Allow it - look for the permission ' +
            'icon in the address bar - or use another browser.',
        'gui.kidsblockLink.launchAttempted': 'Asked the system to start it. Nothing happened? ' +
            'Open it yourself from the Start menu (Windows) or Launchpad (macOS).',
        'gui.kidsblockLink.detected': 'KidsBlock Link is running. Connecting...',
        'gui.kidsblockLink.openInstalled': 'Open the installed KidsBlock Link',
        'gui.kidsblockLink.launchHint':
            'Nothing happened? Open KidsBlock Link yourself from the Start menu (Windows) or ' +
            'Launchpad (macOS).'
    },
    'zh-cn': {
        'gui.kidsblockLink.modalTitle': '需要安装 KidsBlock Link',
        'gui.kidsblockLink.modalIntro':
            '在线版连接硬件需要通过 KidsBlock Link 通信，请确保它正在运行。',
        'gui.kidsblockLink.step1Title': '首次使用，下载并安装对应系统的 KidsBlock Link。',
        'gui.kidsblockLink.step2Title':
            '保持 KidsBlock Link 后台运行，即可连接正常上传代码到主控板。',
        'gui.kidsblockLink.downloadWindows': '下载',
        'gui.kidsblockLink.downloadWindowsActive': '点击下载',
        'gui.kidsblockLink.downloadMac': '下载',
        'gui.kidsblockLink.downloadMacActive': '点击下载',
        'gui.kidsblockLink.detecting': '正在检测本机是否已运行 KidsBlock Link……',
        'gui.kidsblockLink.installedQuestion': '已经安装过 KidsBlock Link？',
        'gui.kidsblockLink.blockedByBrowser': '浏览器拦截了网页访问本机服务（本地网络访问被拒绝），' +
            '所以这里无法确认 Link 是否在运行。请在地址栏的权限图标里允许「本地网络访问」，' +
            '或换一个浏览器。',
        'gui.kidsblockLink.launchAttempted': '已尝试唤起。若没反应，请从开始菜单（Windows）' +
            '或启动台（macOS）手动打开。',
        'gui.kidsblockLink.detected': '已检测到 KidsBlock Link 正在运行，正在连接……',
        'gui.kidsblockLink.openInstalled': '打开已安装的 KidsBlock Link',
        'gui.kidsblockLink.launchHint':
            '没反应？请从开始菜单（Windows）或启动台（macOS）手动打开，并保持后台运行。'
    },
    'zh-tw': {
        'gui.kidsblockLink.modalTitle': '需要安裝 KidsBlock Link',
        'gui.kidsblockLink.modalIntro':
            '線上版連接硬體需要透過 KidsBlock Link 通訊，請確保它正在執行。',
        'gui.kidsblockLink.step1Title': '首次使用，下載並安裝對應系統的 KidsBlock Link。',
        'gui.kidsblockLink.step2Title':
            '保持 KidsBlock Link 背景執行，即可連線正常上傳程式碼到主控板。',
        'gui.kidsblockLink.downloadWindows': '下載',
        'gui.kidsblockLink.downloadWindowsActive': '點擊下載',
        'gui.kidsblockLink.downloadMac': '下載',
        'gui.kidsblockLink.downloadMacActive': '點擊下載',
        'gui.kidsblockLink.detecting': '正在偵測本機是否已執行 KidsBlock Link……',
        'gui.kidsblockLink.installedQuestion': '已經安裝過 KidsBlock Link？',
        'gui.kidsblockLink.blockedByBrowser': '瀏覽器攔截了網頁存取本機服務（本機網路存取被拒絕），' +
            '所以這裡無法確認 Link 是否在執行。請在網址列的權限圖示裡允許「本機網路存取」，' +
            '或換一個瀏覽器。',
        'gui.kidsblockLink.launchAttempted': '已嘗試喚起。若沒反應，請從開始功能表（Windows）' +
            '或啟動台（macOS）手動開啟。',
        'gui.kidsblockLink.detected': '已偵測到 KidsBlock Link 正在執行，正在連線……',
        'gui.kidsblockLink.openInstalled': '開啟已安裝的 KidsBlock Link',
        'gui.kidsblockLink.launchHint':
            '沒反應？請從開始功能表（Windows）或啟動台（macOS）手動開啟，並保持背景執行。'
    }
};

export default kidsblockLinkMessages;
